module.exports = "/assets/429ee82d92caa3b365c8fa6be2419245.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/DT.png
// module id = 2440
// module chunks = 0